module.exports = __webpack_public_path__ + "static/contxto-15299eedea81b7272449defb84ebf41d.png";